import { render } from "./invoicemodal.vue?vue&type=template&id=9b4a9d18"
import script from "./invoicemodal.vue?vue&type=script&lang=js"
export * from "./invoicemodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__